import { useState } from 'preact/hooks';
import { DOCS_URL, FAQ } from '../data/content';
import { useReveal } from '../hooks/useReveal';
import './Faq.scss';

/**
 * FAQ accordion. One open at a time (radio-style) so the section
 * doesn't sprawl when multiple items get clicked. First item opens
 * by default — gives the section visual weight without requiring
 * interaction.
 */
export function Faq() {
	const ref = useReveal<HTMLDivElement>();
	const [open, setOpen] = useState<number | null>(0);
	return (
		<section class="m-faq">
			<div class="m-faq__inner" ref={ref}>
				<header class="m-faq__head">
					<span class="m-faq__eyebrow">questions</span>
					<h2 class="m-faq__title">wondering how it works?</h2>
				</header>
				<ul class="m-faq__list">
					{FAQ.map((item, i) => (
						<li key={i} class={`m-faq__item ${open === i ? 'm-faq__item--open' : ''}`}>
							<button
								class="m-faq__q"
								onClick={() => setOpen(open === i ? null : i)}
								aria-expanded={open === i ? 'true' : 'false'}
							>
								<span>{item.q}</span>
								<span class="m-faq__plus" aria-hidden="true" />
							</button>
							<div class="m-faq__a">
								<p>{item.a}</p>
							</div>
						</li>
					))}
				</ul>
				<div class="m-faq__more">
					<a class="m-faq__doclink" href={DOCS_URL}>
						Read the documentation
						<span class="m-faq__doclink-arrow" aria-hidden="true">→</span>
					</a>
				</div>
			</div>
		</section>
	);
}
